import type { Lead } from '../../../../common/hooks/use-leads-api.hook';
import { LeadReading, leadSource } from '../../../../modules/vendor/analytics/viz/lead-temperature';

/** Column header keys, under VIZ_ANALYTICS.LEADS.CSV, in the order leadsCsv writes them. */
export const LEAD_CSV_COLUMNS = [
  'EMAIL',
  'TEMPERATURE',
  'SCORE',
  'DOWNLOADS',
  'EVENTS',
  'PRODUCTS',
  'FIRST_SEEN',
  'LAST_SEEN',
  'EMAILS_SENT',
  'LAST_EMAILED',
  'CONSENT',
  'SOURCE',
] as const;

const day = (v?: string | null) => (v ? new Date(v).toISOString().slice(0, 10) : '');

/**
 * The leads as a CSV file's text. `temperatureLabel` and `yesNo` put the
 * vendor's language in the cells; UTF-8 BOM so Excel reads accents and Arabic.
 */
export function leadsCsv(
  leads: Lead[],
  readings: Map<string, LeadReading>,
  headers: string[],
  labels: { temperature: (t: LeadReading['temperature']) => string; yes: string; no: string },
): string {
  const cell = (v: unknown) => {
    const s = v == null ? '' : String(v);
    return /[",\n\r;]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [headers.map(cell).join(',')];
  for (const lead of leads) {
    const r = readings.get(lead._id);
    lines.push(
      [
        lead.email,
        r ? labels.temperature(r.temperature) : '',
        r?.score ?? '',
        lead.downloadCount ?? 0,
        lead.eventCount ?? 0,
        (lead.products ?? []).map((p) => p.title).filter(Boolean).join(' | '),
        day(lead.firstSeenAt),
        day(lead.lastSeenAt),
        lead.emailsSent ?? 0,
        day(lead.lastEmailedAt),
        lead.marketingConsent && !lead.unsubscribedAt ? labels.yes : labels.no,
        leadSource(lead) ?? '',
      ]
        .map(cell)
        .join(','),
    );
  }
  return '﻿' + lines.join('\r\n');
}
